export let productCenterUranusEN = {
  title: "PDUranus Virtual Optimization Platform \nfor Intelligent UAVs",
  subtitle:
    "Building high-validity simulation environments, achieving precise and efficient test validation",
  features: [
    {
      title: "Equipped with Proprietary Full-Physical Sensor Models",
      description:
        "Full-physical sensor models enabling ultra-high precision optical simulation and sensor modeling with 95% validity.",
    },
    {
      title:
        "AI-Driven Scenario generation; providing Ultra-High Simulation Fidelity",
      description:
        "Powerful high-validity environmental simulation capability, supporting corner case construction: urban, canyons, dense obstacles, GPS-denied environments",
    },
    {
      title: "Diverse Tool Modules",
      description:
        "Significantly improving simulation convenience and flexibility",
    },
    {
      title: "Multiple Versions & Deployment Options",
      description:
        "Supporting swarm intelligence algorithm testing; fulfilling diverse requirements on different usecases",
    },
  ],
};
export let productCenterUranusCN = {
  title: "PDUranus 智能无人低空\n载具虚拟优化平台",
  subtitle: "构建高逼真的仿真环境，实现精准高效的测试验证",
  features: [
    {
      title: "搭载自研全物理级传感器模型",
      description:
        "全球领先的全物理级传感器模型，实现超高精度的传感器光学仿真，还原度95%",
    },
    {
      title: "AI驱动场景，构建超高仿真还原",
      description:
        "拥有强大的高保真环境模拟能力，支持城市、峡谷、密集障碍物、GPS拒止环境等极端场景构建",
    },
    {
      title: "丰富多样的工具模块",
      description: "显著提高仿真便捷度与灵活度",
    },
    {
      title: "多种版本与部署方式",
      description: "支持群体智能算法测试，满足不同业务使用场景需求",
    },
  ],
};
